import { r as o } from "./abstract-base-CzLmw6_x.js";
import { B as c } from "./breakpoints-3erYeCpk.js";
import { a as u, m as g } from "./lifecycle-decorators-CUsT9aHq.js";
var k = Object.defineProperty, B = Object.getOwnPropertyDescriptor, h = (r, e, a, n) => {
  for (var i = n > 1 ? void 0 : n ? B(e, a) : e, p = r.length - 1, t; p >= 0; p--)
    (t = r[p]) && (i = (n ? t(e, a, i) : t(i)) || i);
  return n && i && k(e, a, i), i;
}, M = (r, e, a) => {
  if (!e.has(r))
    throw TypeError("Cannot " + a);
}, d = (r, e, a) => (M(r, e, "read from private field"), a ? a.call(r) : e.get(r)), m = (r, e, a) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, a);
};
const w = () => function(e) {
  var a, n, i, p;
  let t = class extends e {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(t.createMediaQueryString(c.DEFAULT)), this.mediumBreakpointWatcher = window.matchMedia(t.createMediaQueryString(c.MEDIUM)), this.largeBreakpointWatcher = window.matchMedia(t.createMediaQueryString(c.LARGE)), this.xLargeBreakpointWatcher = window.matchMedia(t.createMediaQueryString(c.XLARGE)), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, m(this, a, ({ matches: s }) => {
        this.isSmallBreakpoint = s;
      }), m(this, n, ({ matches: s }) => {
        this.isMediumBreakpoint = s;
      }), m(this, i, ({ matches: s }) => {
        this.isLargeBreakpoint = s;
      }), m(this, p, ({ matches: s }) => {
        this.isXLargeBreakpoint = s;
      });
    }
    static createMediaQueryString(s) {
      return `(min-width: ${s}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener("change", d(this, a)), this.mediumBreakpointWatcher.addEventListener("change", d(this, n)), this.largeBreakpointWatcher.addEventListener("change", d(this, i)), this.xLargeBreakpointWatcher.addEventListener("change", d(this, p));
    }
  };
  return a = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), h([
    o()
  ], t.prototype, "isSmallBreakpoint", 2), h([
    o()
  ], t.prototype, "isMediumBreakpoint", 2), h([
    o()
  ], t.prototype, "isLargeBreakpoint", 2), h([
    o()
  ], t.prototype, "isXLargeBreakpoint", 2), h([
    u
  ], t.prototype, "prerenderWatchMediaSetup", 1), t = h([
    g("WatchMedia")
  ], t), t;
};
export {
  w as W
};
